import {getApiMetadataWithoutToken} from '../../helpers/api-metadata'
import {getEnabledFeatures} from '../../helpers/feature-flags'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {
  BulkUpdateMemexItemsRequest,
  BulkUpdateMemexItemsResponse,
  BulkUpdateV2MemexItemsResponse,
} from './contracts'

export async function apiBulkUpdateItems(
  body: BulkUpdateMemexItemsRequest,
): Promise<BulkUpdateMemexItemsResponse | BulkUpdateV2MemexItemsResponse> {
  const {memex_bulk_actions_background_job} = getEnabledFeatures()
  if (memex_bulk_actions_background_job) {
    const apiData = getApiMetadataWithoutToken('memex-item-update-bulk-v2-api-data')
    const {data} = await fetchJSONWith<BulkUpdateV2MemexItemsResponse>(apiData.url, {
      method: 'PUT',
      body,
    })
    return data
  }

  const apiData = getApiMetadataWithoutToken('memex-item-update-bulk-api-data')
  const {data} = await fetchJSONWith<BulkUpdateMemexItemsResponse>(apiData.url, {
    method: 'PUT',
    body,
  })
  return data
}
